import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal } from 'react-bootstrap';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { showToast } from '../../../Constants/Toast';

const EssentialsTemplate = ({ loginStatus, link, name, description, initialRequestStatus, redirect }) => {
    const [showModal, setShowModal] = useState(false);

    const handleClose = () => setShowModal(false);

    const handleButtonClick = () => {
        if (loginStatus) {
            if (redirect) {
                window.open(redirect, '_blank');
            } else {
                setShowModal(true);
            }
        }
        else {
            showToast("Please sign in to CharmHealthHub to continue integrating with " + name, "error")
        }
    };

    return (
        <div className="w-full h-fit flex flex-col p-[24px] bg-productBackground">
            <ToastContainer />
            <div className="w-full flex flex-col gap-[10px] items-center h-[252px] xs:h-[228px] sm:h-[208px] md:h-[232px] lg:h-[184px] xl:h-[228px] 1.5xl:h-[256px] 2.5xl:h-[228px] 3xl:h-[208px]">
                <div className="w-[64px] h-[64px] flex-shrink-0 ">
                    {link ? (
                        <img src={link} alt="logo" className="h-full w-full object-contain rounded-2xl" />
                    ) : (
                        <div className="h-full w-full" />
                    )}
                </div>

                <h5 className="w-full xl:h-[64px] text-center text-[26px] font-bold font-proximanova mb-0"
                >
                    {name}
                </h5>
                <p className="w-full text-center text-[18px] line-clamp-5 font-proximanova mb-0" style={{ lineHeight: '1.35' }}>
                    {description}
                </p>

            </div>

            <div className="flex items-center justify-center h-[48px]">
                <div className="flex flex-row items-center">
                    {initialRequestStatus === 'Requested' && (
                        <div className={`h-3 w-3 rounded-full bg-productRequested`}></div>
                    )}
                    {initialRequestStatus === 'Enabled' && (
                        <div className={`h-3 w-3 rounded-full bg-focusOutline`}></div>
                    )}

                    <div className="ml-2">
                        {initialRequestStatus === 'Integrate' ? (
                            <button
                                onClick={handleButtonClick}
                                className="text-white text-[18px] font-proximanova px-[24px] py-[3px] bg-link hover:text-integrationRequestTextHover hover:bg-charmHover w-fit rounded-full"
                            >
                                Integrate
                            </button>
                        ) : (
                            <h3 className="italic text-[18px] font-proximanova mb-0"> {initialRequestStatus}</h3>
                        )}
                    </div>
                </div>
            </div>

            <Modal
                show={showModal}
                onHide={handleClose}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Integration Steps</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <p className="font-proximanova text-[18px] text-[#505050] mb-4">
                            We are working hard to bring direct integrations very soon. Until then, please follow these simple steps to get this product integrated into your system.
                        </p>
                        <div className="font-proximanova text-[18px] text-[#505050] mb-3">
                            <p><strong>Step 1:</strong> Please visit <a href="https://ehr2.charmtracker.com/ehr/main.do" target="_blank" rel="noopener noreferrer">https://ehr2.charmtracker.com/ehr/main.do</a>, log in, and select your facility.</p>
                        </div>
                        <div className="font-proximanova text-[18px] text-[#505050] mb-3 d-flex align-items-center">
                            <p><strong>Step 2:</strong> Click on the settings icon <span className="ml-2 mr-2">&#9881;</span> in the top right corner, and proceed to the settings page.</p>
                        </div>
                        <div className="font-proximanova text-[18px] text-[#505050] mb-3">
                            <p><strong>Step 3:</strong> Search for <strong>{name}</strong> and click on it to integrate.</p>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </div >
    );
}

export default EssentialsTemplate;